import LeadMagnetInput from "@/components/lead-magnet/LeadMagnetInput";

const Hero = () => {
  return (
    <section className="w-full pt-16 pb-12 md:pt-32 md:pb-16">
      <div className="mx-auto max-w-7xl px-6">
        {/* Heading */}
        <div className="max-w-5xl mx-auto text-center space-y-6 md:pt-8">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-normal leading-tight text-foreground animate-fade-in">
            <span className="md:inline">Ecommerce growth</span>
            <br className="md:hidden" />
            <span className="md:inline"> at </span>
            <span className="bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">
              lightspeed
            </span>
          </h1>

          {/* Description - above lead magnet */}
          <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-2xl lg:max-w-none mx-auto animate-fade-in lg:whitespace-nowrap" style={{ animationDelay: '0.1s' }}>
            Combine traffic, page optimization, and operations into one seamless workflow.
          </p>

          {/* Lead Magnet Input */}
          <div className="pt-2 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            <LeadMagnetInput />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;